import React from 'react'
import ReactTooltip, { TooltipProps } from 'react-tooltip'
import styled from 'styled-components'
import { dimensions, light, spacing } from '~/constants/theme'

const StyledTooltip = styled(ReactTooltip)`
  &.type-dark {
    background: ${light.dark900};
    padding: ${spacing.spacingMD} ${spacing.spacingLG};
    border-radius: ${dimensions.borderRadiusSM};
    line-height: 14px;
    font-size: 14px;
  }
  &.type-dark.place-bottom {
    &:after {
      border-bottom-color: ${light.dark900};
    }
  }
  &.type-dark.place-right {
    &:after {
      border-right-color: ${light.dark900};
    }
  }
  &.type-dark.place-left {
    &:after {
      border-left-color: ${light.dark900};
    }
  }
  &.type-dark.place-top {
    &:after {
      border-top-color: ${light.dark900};
    }
    &:before {
      height: 8px;
    }
  }
`

const Tooltip = ({ place = 'bottom', ...props }: TooltipProps) => {
  return <StyledTooltip multiline place={place} effect="solid" {...props} />
}

export default Tooltip
